import React from 'react';
import { Form, Input } from 'antd';

export const AutoSearchFields = (props) => {
 
    const { form } = props;
    const { getFieldDecorator, getFieldValue } = form;
    let kpp = getFieldValue('kpp');
    return (
        <>
            {/*<div className="add-licensee__item-photo">*/}
            {/*    <Form.Item>*/}
            {/*        {getFieldDecorator('companyPhoto', {*/}
            {/*            valuePropName: 'image_url',*/}
            {/*        })(<UploadCompanyPhoto form={form} />)}*/}
            {/*    </Form.Item>*/}
            {/*</div>*/}
            <div className="add-licensee__item">
                <span className="label">Наименование:</span>
                <Form.Item>
                    {getFieldDecorator('nameLegal')(
                        <Input
                            disabled
                            style={{ width: 368 }}
                            placeholder="Укажите наименование компании"
                        />
                    )}
                </Form.Item>
            </div>
            <div className="add-licensee__item">
                <span className="label">Юридический адрес:</span>
                <Form.Item>
                    {getFieldDecorator('addressLegal')(
                        <Input
                            disabled
                            style={{ width: 368 }}
                            placeholder="Укажите юридический адрес"
                        />
                    )}
                </Form.Item>
            </div>
            <div className="add-licensee__item">
                <span className="label">ИНН:</span>
                <Form.Item>
                    {getFieldDecorator('inn')(
                        <Input disabled style={{ width: 368 }} placeholder="Укажите ИНН" />
                    )}
                </Form.Item>
            </div>
            <div className="add-licensee__item" hidden={!kpp ? true : false}>
                <span className="label">КПП:</span>
                <Form.Item>
                    {getFieldDecorator('kpp')(
                        <Input disabled style={{ width: 368 }} placeholder="Укажите КПП" />
                    )}
                </Form.Item>
            </div>
            <div className="add-licensee__item">
                <span className="label">{!kpp ? 'ОГРНИП' : 'ОРГН'}:</span>
                <Form.Item>
                    {getFieldDecorator('ogrn')(
                        <Input disabled style={{ width: 368 }} placeholder="Укажите ОГРН" />
                    )}
                </Form.Item>
            </div>
        </>
    );
};
